"use client";

type AppPreviewInterstitialProps = {
  html: string;
};

/**
 * The CTA lives inside the document so customers can position it in their own
 * layout via a marker. `allow-top-navigation-by-user-activation` is the only
 * capability granted: a link the visitor taps may navigate the top window.
 * Scripts stay disabled, so the CTA is a plain anchor pointing at
 * /api/link/continue rather than a callback into React.
 */
export function AppPreviewInterstitial({ html }: AppPreviewInterstitialProps) {
  return (
    <iframe
      srcDoc={html}
      sandbox="allow-top-navigation-by-user-activation"
      className="fixed inset-0 h-full w-full border-0"
      title="App preview"
    />
  );
}
